import { styled } from '@mui/system'
import { TableCell, TextField } from '@mui/material'

export const StatisticsRowTableCellEdit = styled(TableCell)(() => ({
  paddingBottom: '0',
  paddingTop: '0',
}))

export const StatisticsRowTableCell = styled(TableCell)(() => ({
  position: 'relative',
  width: 'calc(100vw/3)',
  background: 'white',
}))

export const StatisticsRowTextFieldNameInput = styled(TextField)(() => ({
  width: '90%',
  '& input': {
    textAlign: 'center',
  },
}))
